import { jsx } from "react/jsx-runtime";
import { Text, Link } from "braid-design-system";
import { createContext, useContext, useRef, useState, useCallback } from "react";
import { hoverLink } from "../JobDetailsView/JobDetailsView.css.mjs";
const noop = () => {
};
const initialState = {
  reportJobAd: {
    ref: null,
    onReportJobAdDropdownClick: noop,
    setOnReportJobAdDropdownClick: noop
  }
};
const JobDetailsViewContext = createContext(initialState);
const useJobDetailsViewContext = () => {
  const {
    onAnalyticsEvent = noop,
    shouldOpenApplyInNewTab = false,
    featureFlags,
    displayCompanyProfile = false,
    ...result
  } = useContext(JobDetailsViewContext);
  return {
    ...result,
    onAnalyticsEvent,
    shouldOpenApplyInNewTab,
    featureFlags,
    displayCompanyProfile
  };
};
const useJobDetailsViewContextProviderValue = (props) => {
  const reportJobAdRef = useRef(null);
  const [onReportJobAdDropdownClick, setOnReportJobAdDropdownClick] = useState(() => {
  });
  return {
    ...props,
    reportJobAd: {
      ref: reportJobAdRef,
      onReportJobAdDropdownClick,
      setOnReportJobAdDropdownClick
    }
  };
};
const JobDetailsViewContextProvider = ({
  children,
  ...props
}) => {
  const value = useJobDetailsViewContextProviderValue(props);
  return /* @__PURE__ */ jsx(JobDetailsViewContext.Provider, { value, children });
};
const useAnalyticsHandlers = (track) => {
  const onCompanyJobSearchClick = useCallback(
    (evt) => {
      track({
        type: "COMPANY_JOB_SEARCH_LINK_CLICK",
        href: evt.currentTarget.href
      });
    },
    [track]
  );
  const onCompanyProfileClick = useCallback(
    (evt) => {
      track({
        type: "COMPANY_PROFILE_LINK_CLICK",
        href: evt.currentTarget.href
      });
    },
    [track]
  );
  const onCompanyProfileWidgetImpression = useCallback(() => {
    track({
      type: "COMPANY_PROFILE_WIDGET_IMPRESSION"
    });
  }, [track]);
  const onCompanyProfileWidgetAccordionClick = useCallback(
    (showMore) => {
      track({
        type: "COMPANY_PROFILE_WIDGET_ACCORDION_LINK_CLICK",
        linkAction: showMore ? "expand" : "collapsed"
      });
    },
    [track]
  );
  const onCompanyProfileWidgetClick = useCallback(() => {
    track({
      type: "COMPANY_PROFILE_WIDGET_LINK_CLICK",
      linkPosition: "below"
    });
  }, [track]);
  const onCompanyProfileWidgetReviewsClick = useCallback(() => {
    track({
      type: "COMPANY_PROFILE_WIDGET_REVIEWS_LINK_CLICK",
      linkPosition: "below"
    });
  }, [track]);
  const onCompanyReviewsClick = useCallback(
    (evt) => {
      track({
        type: "COMPANY_REVIEWS_LINK_CLICK",
        href: evt.currentTarget.href
      });
    },
    [track]
  );
  const onContactMatchImpression = useCallback(
    (payload) => {
      track({
        type: "CONTACT_MATCH_IMPRESSION",
        contactTypes: payload
      });
    },
    [track]
  );
  const onContactMatchInteraction = useCallback(
    ({ eventType, contactType }) => {
      track({
        type: "CONTACT_MATCH_INTERACTION",
        contactType,
        eventType
      });
    },
    [track]
  );
  const onJobTitleClick = useCallback(
    (evt) => {
      track({
        type: "JOB_TITLE_LINK_CLICK",
        href: evt.currentTarget.href
      });
    },
    [track]
  );
  const onShareEmailClick = useCallback(() => {
    track({
      type: "SHARE_LINK_CLICK",
      channel: "email"
    });
  }, [track]);
  const onShareFacebookClick = useCallback(() => {
    track({
      type: "SHARE_LINK_CLICK",
      channel: "facebook"
    });
  }, [track]);
  const onShareLinkedInClick = useCallback(() => {
    track({
      type: "SHARE_LINK_CLICK",
      channel: "linkedin"
    });
  }, [track]);
  const onShareTwitterClick = useCallback(() => {
    track({
      type: "SHARE_LINK_CLICK",
      channel: "twitter"
    });
  }, [track]);
  const onTopApplicantBadgeClick = useCallback(() => {
    track({
      type: "TOP_APPLICANT_BADGE_CLICK"
    });
  }, [track]);
  const onTopApplicantBadgeImpression = useCallback(() => {
    track({
      type: "TOP_APPLICANT_BADGE_IMPRESSION"
    });
  }, [track]);
  const onSourcrImpression = useCallback(() => {
    track({
      type: "SOURCR_IMPRESSION"
    });
  }, [track]);
  const onSourcrClicked = useCallback(() => {
    track({
      type: "SOURCR_CLICKED"
    });
  }, [track]);
  const onSalaryBadgeClicked = useCallback(() => {
    track({
      type: "SALARY_BADGE_CLICKED"
    });
  }, [track]);
  return {
    onCompanyJobSearchClick,
    onCompanyProfileClick,
    onCompanyProfileWidgetImpression,
    onCompanyProfileWidgetAccordionClick,
    onCompanyProfileWidgetClick,
    onCompanyProfileWidgetReviewsClick,
    onCompanyReviewsClick,
    onContactMatchImpression,
    onContactMatchInteraction,
    onJobTitleClick,
    onShareEmailClick,
    onShareFacebookClick,
    onShareLinkedInClick,
    onShareTwitterClick,
    onTopApplicantBadgeClick,
    onTopApplicantBadgeImpression,
    onSourcrImpression,
    onSourcrClicked,
    onSalaryBadgeClicked
  };
};
const CompanyName = () => {
  const { job, onAnalyticsEvent } = useJobDetailsViewContext();
  const analytics = useAnalyticsHandlers(onAnalyticsEvent);
  return /* @__PURE__ */ jsx(Text, { data: { automation: "advertiser-name" }, children: job.company.profileUrl ? /* @__PURE__ */ jsx(
    Link,
    {
      href: job.company.profileUrl,
      className: hoverLink,
      onClick: analytics.onCompanyProfileClick,
      children: job.company.name
    }
  ) : job.company.name });
};
export {
  CompanyName,
  JobDetailsViewContextProvider,
  useAnalyticsHandlers,
  useJobDetailsViewContext
};
